// 2_components/reset_focus.js
// Blurs whatever element Shoptet auto-focuses after page/products content loads, so
// the viewport doesn't jump to a focused field.

export function init() {
	document.addEventListener("ShoptetDOMPageContentLoaded", () => {
		resetFocus();
	});

	document.addEventListener("ShoptetDOMPageMoreProductsLoaded", () => {
		resetFocus();
	});
}

function resetFocus() {
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			/* 	setTimeout(() => { */
			if (document.activeElement && document.activeElement !== document.body) {
				document.activeElement.blur();
			}
			/* }, 100); */
		});
	});
}

/* function resetFocus() {
	setTimeout(() => {
		if (document.activeElement && document.activeElement !== document.body) {
			document.activeElement.blur();
		}
	}, 1);
}

document.addEventListener("ShoptetDOMPageContentLoaded", () => {
	resetFocus();
});

document.addEventListener("ShoptetDOMPageMoreProductsLoaded", () => {
	resetFocus();
});
 */
